'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = normalizeEvent;

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var omitted = ['action', 'version', 'channel', 'requestTime', 'projectId'];

function normalizeEvent(data) {
  var type = data.type || data.action;

  var context = data.context || {};
  var library = context.library || {};
  if (library === 'segment.js') library = 'analytics.js';
  if (typeof library === 'string') library = { name: library };
  context.library = library;

  var clean = _lodash2.default.apply(undefined, [data].concat(omitted));
  return _extends({}, clean, {
    context: context,
    type: type
  });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OztrQkFLd0IsYzs7QUFKeEI7Ozs7OztBQUVBLElBQU0sVUFBVSxDQUFFLFFBQUYsRUFBWSxTQUFaLEVBQXVCLFNBQXZCLEVBQWtDLGFBQWxDLEVBQWlELFdBQWpELENBQWhCOztBQUVlLFNBQVMsY0FBVCxDQUF5QixJQUF6QixFQUErQjtBQUM1QyxNQUFNLE9BQU8sS0FBSyxJQUFMLElBQWEsS0FBSyxNQUEvQjs7QUFFQSxNQUFNLFVBQVUsS0FBSyxPQUFMLElBQWdCLEVBQWhDO0FBQ0EsTUFBSSxVQUFVLFFBQVEsT0FBUixJQUFtQixFQUFqQztBQUNBLE1BQUksWUFBWSxZQUFoQixFQUE4QixVQUFVLGNBQVY7QUFDOUIsTUFBSSxPQUFPLE9BQVAsS0FBbUIsUUFBdkIsRUFBaUMsVUFBVSxFQUFFLE1BQU0sT0FBUixFQUFWO0FBQ2pDLFVBQVEsT0FBUixHQUFrQixPQUFsQjs7QUFFQSxNQUFNLFFBQVEsbUNBQUssSUFBTCxTQUFjLE9BQWQsRUFBZDtBQUNBLHNCQUNLLEtBREw7QUFFRSxvQkFGRjtBQUdFO0FBSEY7QUFLRCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIlxuaW1wb3J0IG9taXQgZnJvbSAnbG9kYXNoLm9taXQnXG5cbmNvbnN0IG9taXR0ZWQgPSBbICdhY3Rpb24nLCAndmVyc2lvbicsICdjaGFubmVsJywgJ3JlcXVlc3RUaW1lJywgJ3Byb2plY3RJZCcgXVxuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBub3JtYWxpemVFdmVudCAoZGF0YSkge1xuICBjb25zdCB0eXBlID0gZGF0YS50eXBlIHx8IGRhdGEuYWN0aW9uXG5cbiAgY29uc3QgY29udGV4dCA9IGRhdGEuY29udGV4dCB8fCB7fVxuICBsZXQgbGlicmFyeSA9IGNvbnRleHQubGlicmFyeSB8fCB7fVxuICBpZiAobGlicmFyeSA9PT0gJ3NlZ21lbnQuanMnKSBsaWJyYXJ5ID0gJ2FuYWx5dGljcy5qcydcbiAgaWYgKHR5cGVvZiBsaWJyYXJ5ID09PSAnc3RyaW5nJykgbGlicmFyeSA9IHsgbmFtZTogbGlicmFyeSB9XG4gIGNvbnRleHQubGlicmFyeSA9IGxpYnJhcnlcblxuICBjb25zdCBjbGVhbiA9IG9taXQoZGF0YSwgLi4ub21pdHRlZClcbiAgcmV0dXJuIHtcbiAgICAuLi5jbGVhbixcbiAgICBjb250ZXh0LFxuICAgIHR5cGVcbiAgfVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ../~/@segment/normalize-event/lib/index.js
// module id = 1104
// module chunks = 0